import React from 'react';
import EditingContainer from '../EditingContainer';
import locales from './locales.js';

const Radio = ({ children, ...props }) => {
  const id = `${props.name}.${props.value}`;
  return (
    <label htmlFor={id} className="d-f">
      <input {...props} id={id} type="radio" className="f-sh-0" />
      <span className="ml-8">{children}</span>
    </label>
  );
};

const Edit = ({ toggleEditing, availableToEveryone, setLibraryVisibility }) => {
  const handleOptionChange = e => {
    const value = JSON.parse(e.target.value);
    if (value !== availableToEveryone) {
      setLibraryVisibility(value);
    }
  };

  const Option = props => (
    <Radio
      {...props}
      name="addedToLibrary"
      onChange={handleOptionChange}
      checked={availableToEveryone === props.value}
    />
  );

  return (
    <EditingContainer onDone={toggleEditing}>
      <Option value={false}>{locales.notAvailable}</Option>
      <Option value={true}>{locales.available}</Option>
    </EditingContainer>
  );
};

export default Edit;
